import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.571 1.337c-.02-.048-.043-.1-.072-.148a.513.513 0 0 0-.29-.224 2.117 2.117 0 0 0-1.335-.463H2.126C1.468.502.89.788.5 1.246a.413.413 0 0 0-.1.129A2.11 2.11 0 0 0 0 2.623v10.749a2.11 2.11 0 0 0 2.126 2.126h15.748A2.11 2.11 0 0 0 20 13.372V2.628c0-.49-.162-.934-.429-1.291ZM2.126 1.75H17.75l-7.064 5.563-.686.562-7.95-6.12c.023-.005.052-.005.076-.005ZM1.254 13.43V2.72l6.534 5.048-6.534 5.662Zm.948.825 6.587-5.71.834.648c.124.062.248.123.377.123.124 0 .248 0 .377-.185l.757-.596 6.535 5.72H2.202Zm16.544-.877c0 .057-.004.11-.014.157l-6.61-5.782 6.62-5.195a.358.358 0 0 1 .004.071v10.749Z" }, null, -1)
  ]))]))
}
export default { render };